import { ReactNode } from "react";
import { Box, CircularProgress } from "@mui/material";

interface Props {
  /** Muestra el spinner sobre la esquina derecha del campo. */
  loading: boolean;
  children: ReactNode;
}

/**
 * Envuelve un campo de formulario y le sobrepone un spinner mientras carga su catálogo o su
 * consulta asociada (código postal, marcas/modelos de vehículo, etc.). A diferencia de sustituir
 * el campo por un `Skeleton`, el layout no salta y el valor ya seleccionado se sigue viendo.
 *
 * Para un `TextField select`, combinar con `selectLoadingProps` para que el chevron no se encime
 * con el spinner.
 */
export const FieldLoader = ({ loading, children }: Props) => (
  <Box sx={{ position: "relative" }}>
    {children}
    {loading && (
      <CircularProgress size={16} thickness={5} sx={{ position: "absolute", right: 12, top: "50%", mt: "-8px" }} />
    )}
  </Box>
);
